import React, { Component } from "react";
import { connect } from "react-redux";
import { Alert } from "antd";
import Pusher from "react-pusher";
import PatientReferralView from "./PatientReferralView";
import { getReferrals } from "./PatientReferralActions";
import { strings, history } from "../../helpers";
import ViewNotesModalView from "./ViewNotesModalView";

class PatientReferralContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      referralsList: [],
      totalRecords: 0,
      searchText: "",
      showNewReferralAlert: false,
      showNotesModal: false,
      notes: null
    };
  }

  componentDidMount() {
    this.getReferralApiCall();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.referralsList !== state.referralsList) {
      return { referralsList: props.referralsList };
    }
    if (props.totalRecords !== state.totalRecords) {
      return { totalRecords: props.totalRecords };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.referralsList !== this.props.referralsList) {
      this.setState({
        referralsList: this.props.referralsList
      });
    }

    if (prevProps.totalRecords !== this.props.totalRecords) {
      this.setState({
        totalRecords: this.props.totalRecords
      });
    }
  }

  /**
   * @function getReferralApiCall
   * @desc call the  referral list api
   */
  getReferralApiCall = () => {
    this.props.getReferralsList(this.state.activePage);
  };

  /**
   * @function handlePageChange
   * @param activePage - current active page
   * @desc Called when navigation page changes
   */
  handlePageChange = activePage => {
    this.setState({ activePage }, () => {
      this.getReferralApiCall();
    });
  };

  /**
   * @function goToDetailPage
   * @desc navigates user to referral detail page
   */
  goToDetailPage = referralId => {
    history.push(`/book-appointment/${referralId}`);
  };

  /**
   * @function closeNotification
   * @desc function that closed new referral notification alert/ notification
   */
  closeNotification = () => {
    this.setState({ showNewReferralAlert: false });
  };

  /**
   * @function onNewReferralAddition
   * @desc function that handles showing new referral addition alert and call get referral api method
   */
  onNewReferralAddition = () => {
    this.setState({ showNewReferralAlert: true });
    this.reloadPageAfterNotification();
  };

  /**
   * @function reloadPageAfterNotification
   * @desc function that reloads dashboard after a referral is created/ recieved
   */
  reloadPageAfterNotification = () => {
    this.setState({
      activePage: 1
    });

    this.getReferralApiCall();
  };

  /**
   * @function handleKeyPress
   * @param target
   * @desc This function handles keypress on password input field,
   *  if enter key is pressed then search function is called
   */
  handleKeyPress = target => {
    if (target.charCode === 13) {
      this.getReferralApiCall();
    }
  };

  /**
   * @function handleChange
   * @param e
   * @desc This handles the search text input changes
   */
  handleChange = e => {
    const { value } = e.target;
    this.setState({
      searchText: value.replace(/\s/g, "")
    });
  };

  /**
   * @function toggleNotesModal
   * @param notes
   * @desc This handles toggling view notes modal
   */
  toggleNotesModal = notes => {
    this.setState(prevState => ({
      showNotesModal: !prevState.showNotesModal,
      notes
    }));
  };

  render() {
    const {
      referralsList,
      activePage,
      totalRecords,
      showNewReferralAlert,
      searchText,
      showNotesModal,
      notes
    } = this.state;

    const { referralsProcessing } = this.props;

    return (
      <div className="content-container">
        <Pusher
          channel={process.env.REACT_APP_PUSHER_CHANNEL}
          event="new_referral"
          onUpdate={this.onNewReferralAddition}
        />

        <Pusher
          channel={process.env.REACT_APP_PUSHER_CHANNEL}
          event="update_referral"
          onUpdate={this.reloadPageAfterNotification}
        />

        {/* notification alert : to show the new referral notification */}
        {showNewReferralAlert && (
          <Alert
            type="success"
            onClose={this.closeNotification}
            message={strings.referrals.newReferralRecieved}
            closable
          >
            {strings.referrals.newReferralRecieved}
          </Alert>
        )}

        <PatientReferralView
          isProcessing={referralsProcessing}
          referralsList={referralsList}
          goToDetailPage={this.goToDetailPage}
          showNewReferralAlert={showNewReferralAlert}
          handleKeyPress={this.handleKeyPress}
          handleChange={this.handleChange}
          searchText={searchText}
          toggleNotesModal={this.toggleNotesModal}
          totalRecords={totalRecords}
          activePage={activePage}
          handlePageChange={this.handlePageChange}
        />

        {showNotesModal && (
          <ViewNotesModalView
            showNotesModal={showNotesModal}
            toggleNotesModal={this.toggleNotesModal}
            notes={notes}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  referralsProcessing: state.patientReferrals.referralsProcessing,
  referralsList: state.patientReferrals.referralsList,
  referralsError: state.patientReferrals.referralsError,
  totalRecords: state.patientReferrals.totalRecords
});

const mapDispatchToProps = dispatch => ({
  getReferralsList: pageNo => dispatch(getReferrals(pageNo))
});

const connectedPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientReferralContainer);
export { connectedPage as default };
